import React from 'react';

import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';

const ResourceCoverage = React.lazy(() => import('./index'));

/** «Споживання ресурсу» — the target and the range are page state, so the page has one flat route. */
const resourceCoverageRoute = [
  {
    path: Pages.RESOURCE_COVERAGE,
    element: <ResourceCoverage />,
    handle: { permissions: UserPermissions.GasBalanceImbalanceRead },
  },
];

export default resourceCoverageRoute;
